
const AUTH_FOOTER_ALT1 = "© 2024 Lawlabs AB ";
const AUTH_FOOTER_ALT2 = "Stockholm 111 20";


export const AuthFooter = () => {
  return (
    <p className="z-10 text-xs text-medium mt-8 mx-2 text-center">
      {AUTH_FOOTER_ALT1}
      <span className={'text-qura-neutral-balanced'}>{AUTH_FOOTER_ALT2}</span>
    </p>
  );
};


